export default "__VITE_ASSET__Db1_P_XJ__"